import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable()
export class NotificationsService {

    constructor(
        private http: HttpClient
    ) { }

    getAllByTeamId() {
        return this.http.get(environment.serverUrl + '/notification/getAllByTeamId');
    }

}



// WEBPACK FOOTER //
// ./src/app/notifications/notifications.service.ts